"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwTreeViewNode = _interopRequireWildcard(require("./CwTreeViewNode"));

var _IconPath = _interopRequireDefault(require("../../utils/IconPath"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var CwTreeView = function CwTreeView(props) {
  var getItemCollapsed = function getItemCollapsed(item) {
    // isCollapsed flag defaults to true
    return item.isCollapsed === undefined ? true : item.isCollapsed;
  };

  var getUpdatedItems = function getUpdatedItems(item, selectedItem) {
    // recursively build updated children items
    var children = item.children ? item.children.map(function (child) {
      return getUpdatedItems(child, selectedItem);
    }) : undefined;
    var isSelectedItem = item.id === selectedItem.id; // use unique id to determine selection

    item.isSelected = isSelectedItem; // explicitly set for all items. selected item should be mutually exclusive

    item.isCollapsed = isSelectedItem ? !selectedItem.isCollapsed : getItemCollapsed(item); // only toggle for selected item, else use default

    item.children = children; // nested updated children items

    return item;
  };

  var handleClick = function handleClick(selectedItem) {
    // get updated treeview value with changes from selection
    var updatedItems = props.value.map(function (item) {
      return getUpdatedItems(item, selectedItem);
    }); // fire onChange with full updated treeview value

    if (props.onChange) {
      props.onChange(updatedItems);
    } // fire onItemSelected with just selected id
    // to avoid consumer having to iterate through
    // full treeview value to find selected item


    if (props.onItemSelected) {
      props.onItemSelected(selectedItem.id);
    }
  };

  var getTreeViewNode = function getTreeViewNode(item) {
    // recursively build children treeviewnodes
    var children = item.children ? item.children.map(function (child) {
      return getTreeViewNode(child);
    }) : undefined; // create full value prop object for CwTreeViewNode

    var value = {
      id: item.id,
      name: item.name,
      isSelected: item.isSelected === undefined ? false : item.isSelected,
      // isSelected flag defaults to false
      isCollapsed: getItemCollapsed(item),
      children: children // nested CwTreeViewNode elements

    };
    return _react.default.createElement(_CwTreeViewNode.default, {
      key: value.id,
      cwId: "".concat(props.cwId, "_node_").concat(value.id),
      collapseIcon: props.collapseIcon,
      expandIcon: props.expandIcon,
      value: value,
      onClick: handleClick
    }, children);
  }; // iterate through value prop and create treeviewnode elements


  var treeView = props.value.map(function (item) {
    return getTreeViewNode(item);
  });
  return _react.default.createElement("div", {
    "data-cwid": props.cwId,
    style: props.style,
    className: props.className
  }, treeView);
}; // recursive treeviewnode proptype shape


var nodeShape = _objectSpread({}, _CwTreeViewNode.treeViewNodeShape);

nodeShape.children = _propTypes.default.arrayOf(_propTypes.default.shape(nodeShape));
CwTreeView.propTypes = {
  /**
   *  Connectwise element id to be used as unique identifier
   **/
  cwId: _propTypes.default.string,

  /**
   * Collapse icon to display when expanded for treeviewnode with children
   */
  collapseIcon: _propTypes.default.string,

  /**
   * Expand icon to display when collapsed for treeviewnode with children
   */
  expandIcon: _propTypes.default.string,

  /**
   * Treeview layout data
   */
  value: _propTypes.default.arrayOf(_propTypes.default.shape(nodeShape)),

  /**
   * Fires entire updated value layout whenever an item is selected
   */
  onChange: _propTypes.default.func,

  /**
   * Fires selected id whenever an item is selected
   */
  onItemSelected: _propTypes.default.func,

  /**
   * Override the styles of the root element
   */
  style: _propTypes.default.object,

  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes.default.string
};
CwTreeView.defaultProps = {
  cwId: '',
  collapseIcon: _IconPath.default.get('Action_Tree_Collapse'),
  expandIcon: _IconPath.default.get('Action_Tree_Expand')
};
var _default = CwTreeView;
exports.default = _default;